// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"582":"b05554a6","777":"f10cc55a","821":"a4afff1c","832":"a74e7765","876":"51808029"}[chunkId] + ".chunk.js";
};